
export const adminPopupNotification = {
  categoryName: "Test Popup Notifications"
}